"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'reports.access.denied.title': 'Accesso Negato',
    'reports.access.denied.enterprise': 'Gli utenti enterprise non hanno accesso ai report sui costi.',
    'reports.access.denied.general': 'Solo gli utenti principali e i super amministratori possono accedere ai report sui costi.',
};
